import React from 'react';
import styled from 'styled-components';
import { Banner } from '../ui/Banner';
import { LockIcon } from '../../ui/icons';
import { useTranslation } from '../../translations';
import { usePremiumUpgrade } from './PremiumUpgrade';

// Informacja przy funkcji premium, której firma nie ma w planie (F.2): kłódka, tekst i przycisk
// „Chcę Premium”. Jedna postać dla wszystkich ekranów (Ustawienia e-mail, Powiadomienia, płatności,
// Widget), zamiast osobnych komunikatów dopisywanych przy każdej bramce. Poza dostawcą
// (PremiumUpgradeProvider w App.js) sam tekst, bez przycisku.
export default function PremiumNotice({ feature, title, children, compact, style, 'data-cy': dataCy }) {
  const { t } = useTranslation();
  const otworz = usePremiumUpgrade();
  return (
    <Banner
      tone="info"
      compact={compact}
      icon={<LockIcon size={compact ? 16 : 20} />}
      title={title}
      style={style}
      data-cy={dataCy}
      action={otworz ? { label: t('premium.want'), onClick: () => otworz(feature), dataCy: 'premium-want' } : undefined}
    >
      {compact && title ? <strong>{title} </strong> : null}
      {children}
    </Banner>
  );
}

const Przycisk = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-1) var(--sp-3);
  border-radius: var(--r-md);
  border: 1px solid var(--warning-border);
  background: var(--warning-bg);
  color: var(--warning);
  font: inherit;
  font-size: var(--fs-sm);
  font-weight: 600;
  cursor: pointer;
  transition: opacity var(--dur) var(--ease);

  &:hover { opacity: 0.8; }
  &:focus-visible { outline: 2px solid var(--primary); outline-offset: 2px; }
`;

/** Sam przycisk „Chcę Premium” (karta funkcji w profilu). Poza dostawcą nic nie rysuje. */
export function ChcePremiumButton({ feature, className, style }) {
  const { t } = useTranslation();
  const otworz = usePremiumUpgrade();
  if (!otworz) return null;
  return (
    <Przycisk type="button" className={className} style={style} onClick={() => otworz(feature)} data-cy="premium-want">
      {t('premium.want')}
    </Przycisk>
  );
}
